export var ServerStatusTypes;
(function (ServerStatusTypes) {
    ServerStatusTypes["FOCUS_SERVER_DOWN"] = "FOCUS_SERVER_DOWN";
    ServerStatusTypes["FOCUS_SERVER_UP"] = "FOCUS_SERVER_UP";
    ServerStatusTypes["AUTOFOCUS_SERVER_DOWN"] = "AUTOFOCUS_SERVER_DOWN";
    ServerStatusTypes["AUTOFOCUS_SERVER_UP"] = "AUTOFOCUS_SERVER_UP";
    ServerStatusTypes["EVENTS_LOGGER_SERVER_DOWN"] = "EVENTS_LOGGER_SERVER_DOWN";
    ServerStatusTypes["EVENTS_LOGGER_SERVER_UP"] = "EVENTS_LOGGER_SERVER_UP";
})(ServerStatusTypes || (ServerStatusTypes = {}));
//# sourceMappingURL=Status.js.map